import { render, staticRenderFns } from "./HistoStat.vue?vue&type=template&id=55ed8027&"
import script from "./HistoStat.vue?vue&type=script&lang=js&"
export * from "./HistoStat.vue?vue&type=script&lang=js&"
import style0 from "./HistoStat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports